import { MainLayout } from 'shared/ui/layout/main';

import { Tabs } from '../tabs';

export function UsersLayout() {
  return <MainLayout tabs={<Tabs />} />;
}
